import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.funding_requirements.send_penny_transfer_title',
        defaultMessage: 'Send a penny transfer'
    },
    caption: {
        id: '_.funding_requirements.send_penny_transfer_caption',
        defaultMessage:
            "This confirms that you control your company's bank account."
    },
    action: {
        id: '_.funding_requirements.penny_transfer_action',
        defaultMessage: 'Complete transfer'
    },
    captionPending: {
        id: '_.funding_requirements.send_penny_transfer_caption_pending',
        defaultMessage: `We're in the process of verifying the penny transfer`
    }
});
